import React from 'react'

import Window from '@/components/ui/window'

type Props = {
  id?: string

}

function Invoices({}: Props) {

  const RenderPage = () => {

    return (

        <div className="container">


        </div>
    );
  };

  return ( 
    <div className='min-h-screen'>
      <Window content={<><div>how are you.</div></>}  key="Invoice" title='Pending Invoices'/>
    </div>
  ) 
  }

export default Invoices